import * as React from "react";
import { parseImageUrl } from "../../../../drupal/rendering/image_utils.mod";
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types";
import { Link } from "react-router-dom";
import { cleanMultipleHttps } from "../../../../cms/blocks/utils.gen";

export type UpdatesBlockProps = {
  title?: string;
  items: UpdateItemProps[];
  isStyleguide?: boolean;
}

export type UpdateItemProps = {
  category?: string;
  title?: string;
  link?: string;
  field_image?: ParsedMediaImage;

  imageStyleguide?: {
    src: string;
    srcSet: string;
    alt: string;
  }
}

export const UpdatesBlock = (props: UpdatesBlockProps) => {
  const {
    title,
    items,
    isStyleguide,
  } = props;

  return (
    <section className="updates">
      <div className="updates__inner">
        <div className="container container--m grid--block">
          {title &&
            <h2 className="updates__title title--l">{title}</h2>
          }
          <ul className={`updates__list updates__list--${items.length}-items`}>
            {items.map((item, index) => {
              const {
                title,
                category,
                link,
                field_image,
              } = item;
              return (
                <>
                  {isStyleguide
                    ? <li className={`updates__item updates__item--${item.imageStyleguide ? 'has-image' : 'text-only'}`}>
                      <a href={cleanMultipleHttps(link)} className="updates__link">
                        {item.imageStyleguide &&
                          <div className="updates__visual">
                            <img
                              src="/frontend/images/empty.png"
                              data-src={item.imageStyleguide.src}
                              data-srcSet={item.imageStyleguide.srcSet}
                              alt={item.imageStyleguide.alt}
                              width="680"
                              height="680"
                              sizes="auto"
                              className="updates__image lazyload"
                            />
                          </div>
                        }
                        <div className="updates__message">
                          <span className="updates__label label">{category}</span>
                          <h3 className={`updates__item-title title--${index == 0 ? 'm' : 's'}`}>
                            {title}
                            <svg className="updates__icon" aria-hidden="true" width="20px" height="20px"><use xlinkHref="#icon--arrow"></use></svg>
                          </h3>
                        </div>
                      </a>
                    </li>
                    : <li className={`updates__item updates__item--${item.field_image ? 'has-image' : 'text-only'}`}>
                      <a href={cleanMultipleHttps(item.link)} className="updates__link">
                        {item.field_image &&
                          <div className="updates__visual">
                            <img className="updates__image lazyload"
                              src="/frontend/images/empty.png"
                              data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                              data-srcset={`${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['450x450']
                              )} 450x450, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['600x600']
                              )} 600x600, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['1200x1200']
                              )}`}
                              alt={field_image?.field_media_image?.alt}
                              sizes="auto"
                              width="680"
                              height="680"
                            />
                          </div>
                        }
                        <div className="updates__message">
                          <span className="updates__label label">{category}</span>
                          <h3 className={`updates__item-title title--${index == 0 ? 'm' : 's'}`}>
                            {item.title}
                            <svg className="updates__icon" aria-hidden="true" width="20px" height="20px"><use xlinkHref="#icon--arrow"></use></svg>
                          </h3>
                        </div>
                      </a>
                    </li>
                  }
                </>
              )
            })}
          </ul>
        </div>
      </div>
    </section >
  )
}